<template>
	<div class="notice_popup human int">
		<div class="close">
			<img src="/images/mem/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit" style="margin-left: 9px; font-size: 20px">파일 업로드 완료</div>
		<div class="member" style="line-height: 30px;">
			템플릿 내용이 모두 입력되었습니다.<br/>
			중복된 내용이 없는지 확인 후 <br/>
			하단의 '등록하기/수정하기' 버튼을 눌러주세요
		</div>
		<div class="select-btn">
			<!-- <div class="btn" @click="$emit('close')">취소</div> -->
			<div class="btn blue" @click="$emit('close', false)">확인</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {}
	},
    methods: {
	}
}
</script>